module.exports = __webpack_public_path__ + "media/newstyle/images/icon-money-purple-3d2c60078845671d2656f1b614030fd9.svg";